<div class="img-wrapper">
    <div class="lable-block">
      <span class="lable3" *ngIf="product.new" i18n>new</span>
    </div>
    <div class="front">
      <a [routerLink]="['//shop/product/', product.id, product.UnitOfMeasure]">
        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'" 
             [lazyLoad]="ImageSrc ? ImageSrc : product.images[0].small"  
             class="img-fluid lazy-loading" alt="{{ product?.images[0].alt }}">
      </a>
      <div *ngIf="product.availability && !product.availability.isAvailable()" class="overlay unavailable" i18n>Unavailable</div>
          <div *ngIf="product.availability && product.availability.isAvailable()" class="overlay available">
            <div class="overlay-container">
              <div *ngIf="product.availability.isCurrentlyAvailable()"><span class="label">{{"Onhand" | translate }}:</span> {{ product.availability.getAvailableQuantity() }}</div>
              <div *ngIf="product.nodeAvailability && product.nodeAvailability.getAvailableQuantity() > 0"><span class="label">{{"in-my-store" | translate }}:</span> {{ product.nodeAvailability.getAvailableQuantity() }}</div>
              <div *ngIf="product.availability.getFutureQuantity() > 0"><span class="label">{{"future-quantity" | translate }}:</span> {{ product.availability.getFutureQuantity() }}</div>
              <div class="date"><span class="label">{{"ead"}}:</span> {{ product.availability.getEAD() | date }}</div>
              <div class="date" *ngIf="product.nodeAvailability && product.nodeAvailability.getEarliestRecord() && product.nodeAvailability.getEarliestRecord().earliestDisplay === 'Today'"><span class="label" translate>order-by-8</span> {{"Today" | translate}}</div>
              <div class="date" *ngIf="product.nodeAvailability && product.nodeAvailability.getEarliestRecord().totalAvailableQuantity > 0 && product.nodeAvailability.getEarliestRecord() && product.nodeAvailability.getEarliestRecord().earliestDisplay !== 'Today'"><span class="label" translate>available-for-pickup</span> {{ product.nodeAvailability.getEarliestRecord().earliestDisplay }}</div>
          </div>
          
          </div>
    </div>
    <div class="back" *ngIf="onHowerChangeImage && product.images.length > 1">
      <a [routerLink]="['//shop/product/', product.id, product.UnitOfMeasure]">
        <img [src]="ImageSrc ? ImageSrc : product.images[1].small" class="img-fluid lazy-loading" alt="{{ product?.images[1].alt }}">
      </a>
    </div>
    <ul class="product-thumb-list" *ngIf="thumbnail">
      <li class="grid_thumb_img" [class.active]="ImageSrc == image.small" *ngFor="let image of product.images">
        <a href="javascript:void(0)" (mouseover)="ChangeVariantsImage(image.small)">
          <img [lazyLoad]="image.small">
        </a>
      </li>
    </ul>
    <div class="cart-detail">
      <a href="javascript:void(0)" title="Add to Wishlist" (click)="addToWishlist(product)">
        <i class="ti-heart" aria-hidden="true"></i>
      </a>
      <a href="javascript:void(0)" title="Quick View" (click)="QuickView.openModal()">
        <i class="ti-search" aria-hidden="true"></i>
      </a>
      <a href="javascript:void(0)" title="Compare" (click)="addToCompare(product)">
        <i class="ti-reload" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <div class="product-info">
    <div>
      <bar-rating [rate]="5" [readOnly]="true"></bar-rating>
      <a [routerLink]="['//shop/product/', product?.title.replace(' ', '-')]">
        <h6>{{ product?.title | titlecase }}</h6>
      </a>
      <h4>
        {{ product?.newPrice | currency:currency?.currency:'symbol' }}
        <del *ngIf="product?.discount"><span class="money"> {{ product?.price | currency:currency?.currency:'symbol' }}</span></del>
      </h4>
      <ul class="color-variant" *ngIf="Color(product?.variants).length">
        <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{'background-color': color}"
          (click)="ChangeVariants(color, product)">
        </li>
      </ul>
      <div class="add-btn">
        <a href="javascript:void(0)" class="btn btn-outline" title="Add to cart" (click)="CartModal.openModal(product)"
            *ngIf="cartModal" i18n>
            <i class="ti-shopping-cart"></i> Add to cart
        </a>
        <a href="javascript:void(0)" class="btn btn-outline" title="Add to cart" (click)="addToCart(product)"
            *ngIf="!cartModal" i18n>
            <i class="ti-shopping-cart"></i> Add to cart
        </a>
      </div>
    </div>
  </div>
  
  
  <app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
  <app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>
  
  